import { useCallback } from "react";
import TagManager from "react-gtm-module";

export function useKuizVirtualPVAnalyticsCall() {
  const analyticsCall = useCallback((title: string, pagination: string) => {
    TagManager.dataLayer({
      dataLayer: {
        event: "virtual_pv",
        title: title,
        pagination: pagination,
      },
    });
  }, []);

  return analyticsCall;
}
